import {
  PRIMARY_STACK_CLASS_NAME,
  SECONDARY_STACK_CLASS_NAME,
  ICON_STACK_CLASS_NAME,
  WARNING_STACK_CLASS_NAME,
  INFORMATION_STACK_CLASS_NAME,
  HIGHLIGHTED_UPLOAD_DOCUMENT_STACK_CLASS_NAME,
  COLORED_BORDERED_STACK_CLASS_NAME,
  PRIMARY_CONFIRMATION_ICON_STACK_CLASS_NAME,
  SUCCESS_CONFIRMATION_ICON_STACK_CLASS_NAME,
  BORDERED_BACKGROUND_STACK_CLASS_NAME,
  WARNING_ICON_STACK_CLASS_NAME,
} from '../../constants/stack';
import FingoMuiStack, { highlightedUploadDocumentStack } from '../../fingo/components/MuiStack';

const primaryStack = ({ theme }) => ({
  backgroundColor: theme.palette.primary.A400,
});

const iconStack = ({ theme }) => ({
  color: theme.palette.secondary.A500,
  '--svg-secondary-color': theme.palette.secondary.A100,
});

const primaryConfirmationIconStack = ({ theme }) => ({
  color: theme.palette.secondary.A400,
  '--svg-secondary-color': theme.palette.secondary.A200,
});

const successConfirmationIconStack = ({ theme }) => ({
  color: theme.palette.success.A700,
  '--svg-secondary-color': theme.palette.success.A100,
});

const warningIconStack = ({ theme }) => ({
  color: theme.palette.warning.A600,
  '--svg-secondary-color': theme.palette.warning.A100,
});

const secondaryStack = ({ theme }) => ({
  backgroundColor: theme.palette.secondary.A200,
});

const informationStack = ({ theme }) => ({
  backgroundColor: theme.palette.secondary.A200,
  '& .MuiTypography-root': {
    color: theme.palette.secondary.A500,
  },

});

const warningStack = ({ theme }) => ({
  backgroundColor: theme.palette.warning.A100,
  color: theme.palette.warning.A700,
  '& .MuiTypography-root': {
    color: theme.palette.warning.A700,
  },
  '& .MuiIconButton-root': {
    color: theme.palette.warning.A700,
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.warning.A700,
  },
});

const coloredBorderedStack = ({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.secondary.A400,
});

const borderedBackgroundStack = ({ theme }) => ({
  border: '2px solid',
  borderColor: theme.palette.secondary.A200,
  backgroundColor: theme.palette.primary.A100,
  borderRadius: 20,
});

const MuiStack = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiStack.styleOverrides.root({ theme }),
      [`&.${PRIMARY_STACK_CLASS_NAME}`]: primaryStack({ theme }),
      [`&.${ICON_STACK_CLASS_NAME}`]: iconStack({ theme }),
      [`&.${SECONDARY_STACK_CLASS_NAME}`]: secondaryStack({ theme }),
      [`&.${WARNING_STACK_CLASS_NAME}`]: warningStack({ theme }),
      [`&.${INFORMATION_STACK_CLASS_NAME}`]: informationStack({ theme }),
      [`&.${HIGHLIGHTED_UPLOAD_DOCUMENT_STACK_CLASS_NAME}`]: highlightedUploadDocumentStack({ theme, borderColor: theme.palette.secondary.A400 }),
      [`&.${COLORED_BORDERED_STACK_CLASS_NAME}`]: coloredBorderedStack({ theme }),
      [`&.${PRIMARY_CONFIRMATION_ICON_STACK_CLASS_NAME}`]: primaryConfirmationIconStack({ theme }),
      [`&.${SUCCESS_CONFIRMATION_ICON_STACK_CLASS_NAME}`]: successConfirmationIconStack({ theme }),
      [`&.${BORDERED_BACKGROUND_STACK_CLASS_NAME}`]: borderedBackgroundStack({ theme }),
      [`&.${WARNING_ICON_STACK_CLASS_NAME}`]: warningIconStack({ theme }),
    }),
  },
};

export default MuiStack;
